function initHeroShowcase() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.hero-showcase').forEach((hero) => {
    const panels = Array.from(hero.querySelectorAll('.hero-showcase__slide-panel'));
    if (panels.length === 0) return;

    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const prevBtn = hero.querySelector('[data-hero-prev]');
    const nextBtn = hero.querySelector('[data-hero-next]');
    const outerInterval = parseInt(hero.dataset.interval, 10) || 6000;

    let index = 0;
    let outerTimer = null;

    function clearInnerTimer(panel) {
      if (panel._innerTimer) {
        clearInterval(panel._innerTimer);
        panel._innerTimer = null;
      }
    }

    function startInnerRotation(panel) {
      const imgs = Array.from(panel.querySelectorAll('.hero-showcase__slide-img'));
      if (imgs.length < 2 || reduceMotion) return;
      let i = 0;
      panel._innerTimer = setInterval(() => {
        imgs[i].classList.remove('is-active');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-active');
      }, 4000);
    }

    function showPanel(newIndex) {
      panels.forEach((panel, i) => {
        const active = i === newIndex;
        panel.classList.toggle('is-active', active);
        panel.toggleAttribute('inert', !active);
        panel.setAttribute('aria-hidden', String(!active));
        if (active) {
          startInnerRotation(panel);
        } else {
          clearInnerTimer(panel);
        }
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === newIndex));
      index = newIndex;
    }

    function next() {
      showPanel((index + 1) % panels.length);
    }

    function prev() {
      showPanel((index - 1 + panels.length) % panels.length);
    }

    function resetOuterTimer() {
      if (outerTimer) clearInterval(outerTimer);
      outerTimer = null;
      if (panels.length > 1 && !reduceMotion) {
        outerTimer = setInterval(next, outerInterval);
      }
    }

    showPanel(0);
    resetOuterTimer();

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        showPanel(i);
        resetOuterTimer();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prev();
        resetOuterTimer();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        next();
        resetOuterTimer();
      });
    }

    if (panels.length > 1) {
      hero.addEventListener('mouseenter', () => {
        if (outerTimer) {
          clearInterval(outerTimer);
          outerTimer = null;
        }
      });
      hero.addEventListener('mouseleave', resetOuterTimer);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroShowcase);
} else {
  initHeroShowcase();
}
